import { isNumber, isString, round } from 'lodash'
import React from 'react'
import { useStaticLabels } from 'shared/hooks/use-static-labels'

import {
  CurrentUser,
  useCurrentUserContext,
} from '~/views/contexts/CurrentUserContext'

type ForecastedHoursContentProps = {
  estimatedHours?: number | null
  forecastedHours?: number | null
}

export default function ForecastedHoursContent({
  estimatedHours,
  forecastedHours,
}: ForecastedHoursContentProps) {
  return (
    <div className={'flex w-full justify-between'}>
      <span>Forecasted</span>

      <FroecastedHoursValueContent
        forecastedHours={forecastedHours}
        estimatedHours={estimatedHours}
      />
    </div>
  )
}

type FroecastedHoursValueContentProps = {
  estimatedHours?: number | null
  forecastedHours?: number | null
  totalTasksWithUnestimatedHoursCount?: number | null
}

function FroecastedHoursValueContent({
  forecastedHours,
  estimatedHours,
}: FroecastedHoursValueContentProps) {
  const [getCommonLabel] = useStaticLabels(['common'])
  const { currentUser } = useCurrentUserContext()

  const difference =
    isNumber(estimatedHours) && isNumber(forecastedHours)
      ? forecastedHours - estimatedHours
      : 0
  const prettyDifference = prettifyNumber(Math.abs(difference))

  const isSame = difference === 0
  const isGood = !isSame && difference < 0

  const textColor = isSame ? '' : !isGood ? 'text-red-600' : 'text-green-800'
  const textQualifier = isSame
    ? ''
    : !isGood
      ? getCommonLabel('over')
      : getCommonLabel('under')

  return (
    <span>
      <span className={'font-bold'}>
        {prettifyNumber(forecastedHours || 0, currentUser)}
      </span>{' '}
      <span className={`${textColor} lowercase`}>
        ({prettyDifference}
        {textQualifier && ' ' + textQualifier})
      </span>
    </span>
  )
}

function prettifyNumber(
  value?: number | null,
  currentUser?: CurrentUser | null,
) {
  try {
    const countryCode = isString(currentUser?.organization?.countryCode)
      ? currentUser?.organization?.countryCode
      : undefined
    return isNumber(value) ? round(value, 2).toLocaleString(countryCode) : 0
  } catch (error) {
    return 0
  }
}
